import { ref } from 'vue'
import apiClient from '@/api/client'

const isOpen = ref(false)
const customer = ref(null)
const loading = ref(false)
const error = ref(null)

export function useCustomerCardDialog() {

  async function open(customerId) {
    if (!customerId) {
      console.warn('[CustomerCardDialog] No customerId provided')
      return
    }

    console.log(`[CustomerCardDialog] Opening for customer ID: ${customerId}`)
    loading.value = true
    error.value = null
    isOpen.value = true
    customer.value = null

    try {
      const { data } = await apiClient.get(`/jobs/customers/${customerId}/st-detail/`)
      customer.value = data
      console.log(`[CustomerCardDialog] Loaded: ${data.name}`)
    } catch (err) {
      console.error('[CustomerCardDialog] Error loading customer:', err)
      error.value = 'Failed to load customer details'
      if (err?.response?.status === 404) {
        error.value = 'Customer not found'
      }
    } finally {
      loading.value = false
    }
  }

  function close() {
    isOpen.value = false
    customer.value = null
    error.value = null
  }

  return {
    isOpen,
    customer,
    loading,
    error,
    open,
    close,
  }
}
